export class StorageHelper {

  

  readItem(key) {
    let saved = localStorage.getItem(key);
  }

  writeItem(key , value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key) {
    return localStorage.getItem(key);
  }

 
  setItem(key , value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  clearData() {
    localStorage.clear()
  }
}